import { TextField } from "@mui/material";
import moment from "moment";
import { DownloadLinkEnh } from "../../../../components/common/DownloadLink/DownloadLinkEnh";
import {
  SimpleCardContainer,
  SimpleCardContent,
  SimpleCardTitle,
} from "../../../../components/common/SimpleCard/SimpleCard";

export default function BerkasFinalSubmittedFile({ mKSpesialId, berkas }) {
  return (
    <div className="flex flex-col gap-4">
      <SimpleCardContainer>
        <SimpleCardTitle>Lembar Pengesahan</SimpleCardTitle>
        <SimpleCardContent>
          <div>
            Anda <span className="font-bold text-red-500">wajib</span>{" "}
            melampirkan lembar pengesahan{" "}
            <DownloadLinkEnh
              endpoint={`/file/lembar-pengesahan?mk_spesial=${mKSpesialId}`}
              label={"berikut"}
            />{" "}
            pada berkas final
          </div>
        </SimpleCardContent>
      </SimpleCardContainer>

      <SimpleCardContainer>
        <SimpleCardTitle>
          Detail Final Tugas Akhir/Tesis/Disertasi
        </SimpleCardTitle>
        <SimpleCardContent>
          <div className="flex flex-col gap-4">
            <TextField
              name="judul_final"
              value={berkas.judul_final}
              inputProps={{ maxLength: 300 }}
              label="Judul Final (Bahasa Indonesia, maksimal 300 karakter)"
              aria-readonly
              multiline
              fullWidth
            />
            <TextField
              name="abstrak"
              value={berkas.abstrak}
              label="Abstrak (Bahasa Indonesia, maksimal 4000 karakter)"
              aria-readonly
              inputProps={{ maxLength: 4000 }}
              multiline
              fullWidth
            />
            <TextField
              name="judul_final_english"
              value={berkas.judul_final_english}
              label="Judul Final (English, maksimal 300 karakter)"
              aria-readonly
              inputProps={{ maxLength: 300 }}
              multiline
              fullWidth
            />
            <TextField
              name="abstrak_english"
              value={berkas.abstrak_english}
              label="Abstrak (English, maksimal 4000 karakter)"
              aria-readonly
              inputProps={{ maxLength: 4000 }}
              multiline
              fullWidth
            />
            <TextField
              name="kata_kunci"
              value={berkas.kata_kunci}
              label="Kata Kunci (English, maksimal 4000 karakter)"
              aria-readonly
              inputProps={{ maxLength: 300 }}
              multiline
              fullWidth
            />
          </div>
        </SimpleCardContent>
      </SimpleCardContainer>
      <SimpleCardContainer>
        <SimpleCardTitle>Berkas Final</SimpleCardTitle>
        <SimpleCardContent>
          <div className="flex flex-col gap-4">
            <div>
              Berkas:{" "}
              <DownloadLinkEnh
                endpoint={`/file/berkas/${berkas.berkas}/`}
                label={"Unduh"}
              />
            </div>
            <div>
              Diunggah pada:{" "}
              {moment(berkas.timestamp).format("DD MMMM YYYY, h:mm a")}
            </div>
          </div>
        </SimpleCardContent>
      </SimpleCardContainer>
    </div>
  );
}
